<template>
    <div class="footer">
        <div class="scheduled">
            <el-row :gutter="12">
                <el-col :span="8"><img src="../../static/footer/scheduled.png"/></el-col>
                <el-col :span="8"><h3>货物跟踪就找物流源</h3></el-col>
                <el-col :span="8"><el-button @click="mark()">预约演示</el-button></el-col>
            </el-row>
        </div>
        <div class="footerContent">
            <div class="footerNav">
                快速导航
            </div>
            <span class="footer-line">
            </span>
            <div class="contact">
                <div class="information">
                    <div class="hotline">
                        <img class="league" src="../../static/footer/league.png" alt="诚信联盟"></img>
                        <img class="hotlineImg" src="../../static/footer/hotline.png" alt="热线电话">
                        <span>免费客服热线：
                            <span class="hotLineNum">4008-539-529</span>
                        </span>
                    </div>
                    <div class="jumpTo">
                        <img class="logo" src="../../static/footer/logo.png" alt="logo"></img>
                        <ul class="ulOne">
                            <li ><span class="jumpToItem">数字供应链服务</span></li>
                            <li ><a href="javascript:;" class="jumpToItem" @click="interior('scheme-Management')">物流数字化 无纸化服务</a></li>
                            <li ><a href="javascript:;" class="jumpToItem" @click="interior('scheme-Visual')">货物跟踪可视化服务</a></li>
                            <li ><a href="javascript:;" class="jumpToItem" @click="interior('scheme-Digitization')">企业管理数据化驾驶舱</a></li>
                            <!-- <li ><a href="javascript:;" class="jumpToItem" @click="interior('scheme-Digitization')">企业管理数据化驾驶舱</a></li> -->
                        </ul>
                        <ul class="ulTwo">
                            <li ><span class="jumpToItem">行业案例</span></li>
                            <li ><a href="javascript:;" class="jumpToItem" @click="interior('case-FMCG')">脱普日化</a></li>
                            <!-- <li ><a href="javascript:;" class="jumpToItem" @click="interior('case-FMCG')">孩子王</a></li> -->
                            <li ><a href="javascript:;" class="jumpToItem" @click="interior('case-Tripartite')">大田物流</a></li>
                        </ul>
                        <ul class="ulThree">
                            <li ><span class="jumpToItem">服务与支持</span></li>
                            <li ><a href="javascript:;" class="jumpToItem" @click="interior('support')">API接口</a></li>
                        </ul>
                        <ul class="ulFour">
                            <li ><span class="jumpToItem">关于我们</span></li>
                            <li ><a href="javascript:;" class="jumpToItem" @click="aboutUsUs('1')">联系我们</a></li>
                            <li ><a href="javascript:;" class="jumpToItem" @click="aboutUsUs('2')">新闻资讯</a></li>
                            <li ><a href="javascript:;" class="jumpToItem" @click="aboutUsUs('3')">招贤纳士</a></li>
                        </ul>
                    </div>
                </div>
                <div class="QRCode">
                    <div class="QR-container">
                        <img src="../../static/footer/QRCode.png" alt="热线电话">
                    </div>
                </div>
            </div>
            <div class="copyright">
                <span>
                    Copyright©2005 上海南软信息科技有限公司版权所有 <a href="https://beian.miit.gov.cn" style="color: #ffffff;">沪ICP备15052516号-1</a>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"footer-content",
    data() {
        return{

        }
    },
    methods: {
        interior (name) {
            this.$router.push({ name: name })
        },
        aboutUsUs (type) {
            this.$router.push({ name: 'aboutUsUs', query: {activeIndex: type} })
        },
        mark () {
            window.open('https://jinshuju.net/f/M6hUEl', '_blank');
        }
    }
}
</script>
<style lang="scss">
    .footer {
        ul {
            list-style: none;
            margin: 0;
            padding: 0;  
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue